import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import * as HelpMessages from '../../Services/helpMessages';

class MostSuitableJobsCard extends Component {
  render() {
    const { t } = this.props;
    return (
      <div>
        {this.props.mostSuitableApplication && (
          <div className="card card-default">
            <div className="card-body">
              <table className="table table-striped table-bordered mb-mails">
                <thead>
                  <tr className="lead">
                    <td className="text-success">{t('modals.SUCCESS_ADDED_APPLICATION')}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div className="d-flex">
                        <em className="icon-briefcase fa-3x"></em>&nbsp;&nbsp;
                        <div className="mb-mail-meta">
                          <div className="mb-mail-subject">
                            {this.props.mostSuitableApplication.job.title},{' Company: '}
                            {this.props.mostSuitableApplication.job.company?.name}
                          </div>
                          {this.props.mostSuitableApplication.score &&
                            this.props.mostSuitableApplication.score.applicantCompetenceAnalisys &&
                            this.props.mostSuitableApplication.score.applicantCompetenceAnalisys.map(
                              (item2, index2) => (
                                <div key={index2}>
                                  <div className="mb-mail-from">
                                    {t('competences.COMPETENCE')}: {item2.competenceName}
                                  </div>
                                  <div className="mb-mail-preview">
                                    {t('modals.ESTIMATED_EXPERIENCE')}: {item2.estimatedExperience}
                                  </div>
                                </div>
                              )
                            )}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
        {this.props.applications && this.props.applications.length > 0 ? (
          <div className="card card-default">
            <div className="card-body">
              <table className="table table-striped table-bordered mb-mails">
                <thead>
                  <tr className="lead">
                    <td className="text-success">{t('modals.MOST_SUITABLE_JOBS_FOR_COMPETENCES')}:</td>
                  </tr>
                </thead>
                <tbody>
                  {this.props.applications.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div className="d-flex">
                          <em className="icon-briefcase fa-3x"></em>&nbsp;&nbsp;
                          <div className="mb-mail-meta">
                            <div className="mb-mail-subject">
                              {item.job ? (
                                item.job.title + ', Company: ' + item.job?.company?.name
                              ) : (
                                <p className="lead text-warning">
                                  <b>{t('modals.NO_JOBS_FOR_CANDIDATE')}</b>
                                </p>
                              )}
                            </div>
                            {item.score &&
                              item.score.applicantCompetenceAnalisys.map((item2, index2) => (
                                <div key={index2}>
                                  <div className="mb-mail-from">
                                    {t('competences.COMPETENCE')}: {item2.competenceName}
                                  </div>
                                  <div className="mb-mail-preview">
                                    {t('modals.ESTIMATED_EXPERIENCE')}: {item2.estimatedExperience}
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <p className="lead text-warning">{HelpMessages.getNoSuitableJobsMsg(this.props.i18n.language)}</p>
        )}
      </div>
    );
  }
}

export default withTranslation('translations')(MostSuitableJobsCard);
